import { useState } from "react";
import { adminApi } from "../../../lib/adminApi";
import { Card, TextArea, Btn, run, fmtDateTime } from "../AdminUI";

export const NotesTab = ({ sh, apply }) => {
  const [text, setText] = useState("");
  const add = async () => {
    const r = await run(() => adminApi.post(`/admin/shipments/${sh.tracking_number}/notes`, { text }), "Note added");
    if (r) { apply(r.data); setText(""); }
  };
  return (
    <Card title="Internal notes" testid="notes-tab" actions={<span className="text-xs text-slate-500">Never shown publicly</span>}>
      <TextArea label="New note" value={text} onChange={setText} testid="note-input" />
      <div className="mt-3 flex justify-end"><Btn onClick={add} disabled={!text.trim()} data-testid="note-add-button">Add note</Btn></div>
      <ul className="mt-6 space-y-3" data-testid="notes-list">
        {sh.internal_notes.length === 0 && <li className="text-sm text-slate-500">No notes yet.</li>}
        {sh.internal_notes.map((n) => (
          <li key={n.id} className="bg-slate-50 border border-slate-200 p-4" data-testid={`note-${n.id}`}>
            <p className="text-sm text-slate-800 whitespace-pre-wrap">{n.text}</p>
            <p className="mt-2 text-xs text-slate-500">{n.author} · {fmtDateTime(n.created_at)}</p>
          </li>
        ))}
      </ul>
    </Card>
  );
};

const ROLE = { customer_confirmation: "Booking confirmation", company_notification: "Company notification", invoice: "Invoice", status_update: "Status update" };

export const EmailsTab = ({ sh }) => (
  <Card title="Email delivery log" testid="emails-tab">
    {sh.email_log.length === 0 ? <p className="text-sm text-slate-500">No emails yet.</p> : (
      <div className="overflow-x-auto -mx-5">
        <table className="w-full text-sm min-w-[720px]" data-testid="email-log-table">
          <thead><tr className="text-left font-mono text-[10px] uppercase tracking-[0.15em] text-slate-500 border-b border-slate-200">
            {["When", "Type", "To", "Subject", "Result"].map((h) => <th key={h} className="px-5 py-3 font-medium">{h}</th>)}
          </tr></thead>
          <tbody>
            {sh.email_log.map((e, i) => (
              <tr key={i} className="border-b border-slate-100 align-top" data-testid={`email-log-${i}`}>
                <td className="px-5 py-3 text-xs text-slate-500 whitespace-nowrap">{e.at ? fmtDateTime(e.at) : "—"}</td>
                <td className="px-5 py-3 text-slate-800">{ROLE[e.role] || e.role}</td>
                <td className="px-5 py-3 text-slate-700 break-all">{e.to}</td>
                <td className="px-5 py-3 text-slate-600">{e.subject || "—"}</td>
                <td className="px-5 py-3">
                  <span className={`inline-block px-2 py-0.5 text-xs font-mono uppercase border ${e.status === "sent" ? "bg-emerald-50 text-emerald-700 border-emerald-200" : "bg-red-50 text-red-700 border-red-200"}`} data-testid={`email-log-status-${i}`}>{e.status}</span>
                  {e.error && <p className="mt-1 text-xs text-red-700 max-w-xs">{e.error}</p>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )}
  </Card>
);
